// frontend/src/pages/PurchaseList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";

const api = {
  list: () => fetch("/api/v1/purchase.order", { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then((r: any) => r.json()).then((r: any) => r.ok ? r.data : []),
  confirm: (id: number) => fetch(`/api/v1/purchase.order/${id}/confirm`, { method: "POST", headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then(() => {}),
  cancel: (id: number) => fetch(`/api/v1/purchase.order/${id}/cancel`, { method: "POST", headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }),
};

const stateColors: Record<string, string> = { draft: "bg-gray-100 text-gray-700", sent: "bg-blue-100 text-blue-700", confirmed: "bg-green-100 text-green-700", done: "bg-teal-100 text-teal-700", cancel: "bg-red-100 text-red-700" };

export default function PurchaseList() {
  const qc = useQueryClient();
  const { data: orders } = useQuery({ queryKey: ["purchases"], queryFn: api.list });
  const confirmMut = useMutation({ mutationFn: api.confirm, onSuccess: () => qc.invalidateQueries({ queryKey: ["purchases"] }) });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Purchase Orders</h1>
        <Link to="/purchases/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ New PO</Link>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Reference</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Vendor</th>
              <th className="text-center px-4 py-3 font-medium text-gray-600">State</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Total</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {orders?.map((o: any) => (
              <tr key={o.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{o.name}</td>
                <td className="px-4 py-3 text-gray-600">{o.partner_id ?? "—"}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${stateColors[o.state] ?? ""}`}>{o.state}</span>
                </td>
                <td className="px-4 py-3 text-right">${(o.amount_total ?? 0).toFixed(2)}</td>
                <td className="px-4 py-3 text-right space-x-2">
                  {o.state === "draft" && <button onClick={() => confirmMut.mutate(o.id)} className="text-green-600 hover:text-green-800 text-xs font-medium">Confirm</button>}
                  {o.state !== "done" && o.state !== "cancel" && <button onClick={() => {}} className="text-red-600 hover:text-red-800 text-xs font-medium">Cancel</button>}
                </td>
              </tr>
            ))}
            {(!orders || orders.length === 0) && <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400">No purchase orders</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
